import { type PropsWithChildren } from "react";

import { TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";

import { FIXED_NAME_COLUMN_ID } from "../constants";

export const TableHeaderCell = (
  props: PropsWithChildren<TableHeaderRow.CellProps>,
) => {
  const leftOffset = 0;

  return (
    <TableHeaderRow.Cell
      {...props}
      style={
        props.column.name === FIXED_NAME_COLUMN_ID
          ? { left: `${leftOffset}px` }
          : {}
      }
    />
  );
};
